import { bridge } from '~/services/bridge'

interface Props {
  handleCollapseClick: () => void
  handleRoot: () => void
}

interface NewLogoProps {
  handleRoot: () => void
}

function NewLogo({ handleRoot }: NewLogoProps) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='cursor-pointer text-tokens-neutral-icon-default'
      onClick={handleRoot}
    >
      <g clipPath='url(#clip0_1666_11728)'>
        <path
          d='M9.1665 3.33325H3.33317C2.89114 3.33325 2.46722 3.50885 2.15466 3.82141C1.8421 4.13397 1.6665 4.55789 1.6665 4.99992V16.6666C1.6665 17.1086 1.8421 17.5325 2.15466 17.8451C2.46722 18.1577 2.89114 18.3333 3.33317 18.3333H14.9998C15.4419 18.3333 15.8658 18.1577 16.1783 17.8451C16.4909 17.5325 16.6665 17.1086 16.6665 16.6666V10.8333'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.4165 2.08344C15.748 1.75192 16.1977 1.56567 16.6665 1.56567C17.1353 1.56567 17.585 1.75192 17.9165 2.08344C18.248 2.41496 18.4343 2.8646 18.4343 3.33344C18.4343 3.80228 18.248 4.25192 17.9165 4.58344L9.99984 12.5001L6.6665 13.3334L7.49984 10.0001L15.4165 2.08344Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1666_11728'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

function CollapsedLogoSvg() {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='text-tokens-neutral-icon-default'
    >
      <path
        d='M16.4736 0.926758C17.9094 0.926758 19.0732 2.09065 19.0732 3.52637V16.4736C19.0732 17.9094 17.9094 19.0732 16.4736 19.0732H3.52637C2.09074 19.0731 0.926758 17.9093 0.926758 16.4736V3.52637C0.926798 2.09074 2.09077 0.926904 3.52637 0.926758H16.4736ZM7.97559 17.5732H16.4736C17.081 17.5732 17.5732 17.081 17.5732 16.4736V3.52637C17.5732 2.91908 17.0809 2.42676 16.4736 2.42676H7.97559V17.5732ZM3.52637 2.42676C2.9192 2.4269 2.4268 2.91917 2.42676 3.52637V16.4736C2.42676 17.0809 2.91917 17.5731 3.52637 17.5732H6.47559V2.42676H3.52637Z'
        fill='currentColor'
      />
    </svg>
  )
}

function NewLogoSvg() {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='text-tokens-neutral-icon-default'
    >
      <g clipPath='url(#clip_sidebar_new)'>
        <path
          d='M9.1665 3.33325H3.33317C2.89114 3.33325 2.46722 3.50885 2.15466 3.82141C1.8421 4.13397 1.6665 4.55789 1.6665 4.99992V16.6666C1.6665 17.1086 1.8421 17.5325 2.15466 17.8451C2.46722 18.1577 2.89114 18.3333 3.33317 18.3333H14.9998C15.4419 18.3333 15.8658 18.1577 16.1783 17.8451C16.4909 17.5325 16.6665 17.1086 16.6665 16.6666V10.8333'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M15.4165 2.08344C15.748 1.75192 16.1977 1.56567 16.6665 1.56567C17.1353 1.56567 17.585 1.75192 17.9165 2.08344C18.248 2.41496 18.4343 2.8646 18.4343 3.33344C18.4343 3.80228 18.248 4.25192 17.9165 4.58344L9.99984 12.5001L6.6665 13.3334L7.49984 10.0001L15.4165 2.08344Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip_sidebar_new'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

interface CollapsedLogoProps {
  handleCollapseClick: () => void
}

function CollapsedLogo({ handleCollapseClick }: CollapsedLogoProps) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='cursor-pointer text-tokens-neutral-icon-default'
      onClick={handleCollapseClick}
    >
      <path
        d='M16.4736 0.926758C17.9094 0.926758 19.0732 2.09065 19.0732 3.52637V16.4736C19.0732 17.9094 17.9094 19.0732 16.4736 19.0732H3.52637C2.09074 19.0731 0.926758 17.9093 0.926758 16.4736V3.52637C0.926798 2.09074 2.09077 0.926904 3.52637 0.926758H16.4736ZM7.97559 17.5732H16.4736C17.081 17.5732 17.5732 17.081 17.5732 16.4736V3.52637C17.5732 2.91908 17.0809 2.42676 16.4736 2.42676H7.97559V17.5732ZM3.52637 2.42676C2.9192 2.4269 2.4268 2.91917 2.42676 3.52637V16.4736C2.42676 17.0809 2.91917 17.5731 3.52637 17.5732H6.47559V2.42676H3.52637Z'
        fill='currentColor'
      />
    </svg>
  )
}

interface LogoProps {
  handleRoot: () => void
}

function Logo({ handleRoot }: LogoProps) {
  return (
    <svg
      width='94'
      height='18'
      viewBox='0 0 94 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='sidebar-logo'
      className='cursor-pointer text-tokens-neutral-icon-default'
      onClick={handleRoot}
    >
      <mask
        id='mask0_1666_11694'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='94'
        height='18'
      >
        <path d='M94 0.0910645H0V17.9088H94V0.0910645Z' fill='white' />
      </mask>
      <g mask='url(#mask0_1666_11694)'>
        <path
          d='M6.74872 15.8227C5.54997 15.8227 4.49084 15.5494 3.57142 15.003C2.652 14.4566 1.93041 13.6859 1.40664 12.6908C0.882975 11.6958 0.621094 10.531 0.621094 9.19658C0.621094 7.85068 0.882975 6.68012 1.40664 5.6851C1.93041 4.69002 2.652 3.91929 3.57142 3.37286C4.49084 2.82643 5.54997 2.55322 6.74872 2.55322C7.72635 2.55322 8.61086 2.74303 9.40226 3.12265C10.1938 3.50227 10.8454 4.03719 11.3576 4.72741C11.8755 5.41763 12.2072 6.23152 12.3527 7.1691H10.0046C9.83004 6.35227 9.45472 5.7196 8.87859 5.27096C8.30247 4.82232 7.59833 4.598 6.76618 4.598C5.97477 4.598 5.29106 4.78781 4.71494 5.16743C4.14467 5.547 3.70529 6.08195 3.3969 6.77215C3.09426 7.46245 2.94294 8.27056 2.94294 9.19658C2.94294 10.1169 3.09426 10.9221 3.3969 11.6124C3.70529 12.2968 4.14467 12.8289 4.71494 13.2085C5.28521 13.5881 5.96893 13.778 6.76618 13.778C7.59248 13.778 8.29375 13.5564 8.86987 13.1135C9.44599 12.6707 9.82707 12.0409 10.0133 11.2241H12.3527C12.2072 12.1616 11.8755 12.9755 11.3576 13.6657C10.8454 14.3502 10.1938 14.8823 9.40226 15.2619C8.61086 15.6358 7.72635 15.8227 6.74872 15.8227Z'
          fill='#65558F'
        />
        <path
          d='M16.1326 15.7969C15.1667 15.7969 14.3782 15.4892 13.7671 14.8737C13.1561 14.2583 12.8506 13.3668 12.8506 12.1992V6.50488H15.0503V11.854C15.0503 12.5213 15.2132 13.0274 15.5391 13.3725C15.865 13.7176 16.3218 13.8902 16.9095 13.8902C17.4914 13.8902 17.9715 13.7119 18.3497 13.3552C18.7339 12.9987 18.9259 12.4321 18.9259 11.6556V6.50488H21.1343V15.6157H18.9695V14.218C18.3236 15.2706 17.378 15.7969 16.1326 15.7969Z'
          fill='#65558F'
        />
        <path
          d='M22.0264 15.6156V6.50481H24.1474V8.01459H24.1737C24.3424 7.49699 24.6072 7.10298 24.968 6.83266C25.3346 6.55656 26.0863 6.47021 26.6798 6.47021C26.8312 6.47021 26.965 6.476 27.0814 6.48747C27.2036 6.49325 27.3083 6.49903 27.3957 6.50481V8.43741C27.3142 8.42585 27.1745 8.41154 26.9766 8.39419C26.7788 8.37694 26.5723 8.36832 26.3569 8.36832C25.8332 8.36832 25.1193 8.49485 24.7584 8.85152C24.4035 9.20808 24.226 9.74303 24.226 10.4563V15.6156H22.0264Z'
          fill='#65558F'
        />
        <path
          d='M27.396 15.6156V6.50483H29.5956V15.6156H27.396ZM28.4958 5.15023C28.1175 5.15023 27.8032 5.03232 27.5531 4.79649C27.3029 4.55491 27.1777 4.2587 27.1777 3.90784C27.1777 3.55697 27.3029 3.26363 27.5531 3.02781C27.8032 2.79198 28.1175 2.67407 28.4958 2.67407C28.8682 2.67407 29.1795 2.79198 29.4298 3.02781C29.68 3.26363 29.8051 3.55697 29.8051 3.90784C29.8051 4.2587 29.68 4.55491 29.4298 4.79649C29.1795 5.03232 28.8682 5.15023 28.4958 5.15023Z'
          fill='#65558F'
        />
        <path
          d='M34.5461 15.8226C33.6267 15.8226 32.8295 15.6185 32.1544 15.21C31.4794 14.8016 30.9586 14.2409 30.5919 13.5277C30.2312 12.8086 30.0508 11.9891 30.0508 11.0687C30.0508 10.1427 30.237 9.32304 30.6094 8.60981C30.9877 7.89089 31.5084 7.32713 32.1718 6.91881C32.8352 6.50471 33.5976 6.29761 34.4589 6.29761C35.3434 6.29761 36.1173 6.49892 36.7807 6.90156C37.4441 7.30419 37.959 7.86208 38.3257 8.57531C38.6923 9.28276 38.8756 10.1024 38.8756 11.0342V11.6296H32.2067C32.2359 12.3715 32.457 12.9697 32.8702 13.4241C33.2833 13.8785 33.8594 14.1057 34.5985 14.1057C35.1513 14.1057 35.6081 13.9878 35.9689 13.7519C36.3297 13.5104 36.5741 13.194 36.7022 12.8029H38.7621C38.6457 13.3953 38.3897 13.9187 37.994 14.3731C37.6041 14.8276 37.1124 15.1842 36.5188 15.443C35.9253 15.6961 35.2677 15.8226 34.5461 15.8226ZM32.2243 10.1283H36.7633C36.6934 9.47839 36.4548 8.96648 36.0474 8.59256C35.6459 8.21296 35.128 8.02311 34.4938 8.02311C33.8536 8.02311 33.3328 8.21296 32.9313 8.59256C32.5356 8.96648 32.2998 9.47839 32.2243 10.1283Z'
          fill='#65558F'
        />
        <path
          d='M37.7202 4.736V2.76025H48.1163V4.736H44.0835V15.6155H41.7704V4.736H37.7202Z'
          fill='#65558F'
        />
        <path
          d='M49.7463 15.8226C48.8269 15.8226 48.0297 15.6185 47.3547 15.21C46.6796 14.8016 46.1588 14.2409 45.7922 13.5277C45.4314 12.8086 45.251 11.9891 45.251 11.0687C45.251 10.1427 45.4372 9.32304 45.8097 8.60981C46.1879 7.89089 46.7087 7.32713 47.3721 6.91881C48.0355 6.50471 48.7979 6.29761 49.6591 6.29761C50.5436 6.29761 51.3175 6.49892 51.9809 6.90156C52.6443 7.30419 53.1593 7.86208 53.5259 8.57531C53.8925 9.28276 54.0759 10.1024 54.0759 11.0342V11.6296H47.407C47.4361 12.3715 47.6572 12.9697 48.0704 13.4241C48.4836 13.8785 49.0596 14.1057 49.7987 14.1057C50.3516 14.1057 50.8083 13.9878 51.1692 13.7519C51.5299 13.5104 51.7744 13.194 51.9024 12.8029H53.9624C53.846 13.3953 53.59 13.9187 53.1942 14.3731C52.8043 14.8276 52.3126 15.1842 51.719 15.443C51.1256 15.6961 50.4679 15.8226 49.7463 15.8226ZM47.4245 10.1283H51.9635C51.8936 9.47839 51.6551 8.96648 51.2477 8.59256C50.8462 8.21296 50.3283 8.02311 49.694 8.02311C49.0539 8.02311 48.5331 8.21296 48.1315 8.59256C47.7358 8.96648 47.5001 9.47839 47.4245 10.1283Z'
          fill='#65558F'
        />
        <path
          d='M59.1686 15.8226C58.2724 15.8226 57.484 15.6213 56.803 15.2187C56.1281 14.816 55.6014 14.2581 55.2232 13.5449C54.8508 12.8317 54.6646 12.0063 54.6646 11.0687C54.6646 10.1312 54.8508 9.30579 55.2232 8.59256C55.6014 7.87364 56.1281 7.31282 56.803 6.91018C57.484 6.50177 58.2724 6.29761 59.1686 6.29761C59.9426 6.29761 60.6321 6.44717 61.2373 6.74621C61.8426 7.03956 62.3285 7.44798 62.6951 7.97136C63.0675 8.48906 63.2857 9.08723 63.3497 9.76596H61.1937C61.1123 9.27708 60.8999 8.88013 60.5565 8.57531C60.219 8.26471 59.7651 8.10946 59.1948 8.10946C58.4732 8.10946 57.9088 8.37684 57.5014 8.91179C57.0941 9.44674 56.8904 10.1657 56.8904 11.0687C56.8904 11.966 57.0941 12.6821 57.5014 13.2171C57.9088 13.7462 58.4732 14.0108 59.1948 14.0108C59.7709 14.0108 60.219 13.8612 60.539 13.5622C60.8591 13.2573 61.0715 12.8518 61.1762 12.3456H63.3497C63.2974 13.0128 63.085 13.6081 62.7125 14.1316C62.3459 14.655 61.8571 15.0691 61.246 15.374C60.6409 15.673 59.9484 15.8226 59.1686 15.8226Z'
          fill='#65558F'
        />
        <path
          d='M66.548 10.4648V15.6155H64.3486V2.76025H66.548V7.84201C67.1886 6.82965 68.1197 6.32351 69.3414 6.32351C70.308 6.32351 71.0962 6.63127 71.707 7.24669C72.3236 7.86211 72.6324 8.75362 72.6324 9.92124V15.6155H70.424V10.2663C70.424 9.59917 70.261 9.09304 69.935 8.74794C69.6089 8.40284 69.1525 8.23024 68.5646 8.23024C67.9883 8.23024 67.5089 8.40852 67.1243 8.76519C66.7408 9.12176 66.548 9.68836 66.548 10.4648Z'
          fill='#65558F'
        />
        <path
          d='M76.2251 15.6155L78.5467 9.18791L80.8692 2.76025H83.767L88.3929 15.6155H85.8527L84.8142 12.5441H79.7693L78.7039 15.6155H76.2251ZM80.4146 10.6719H84.1861L83.5743 8.86006C83.3825 8.26758 83.185 7.64932 82.9807 7.00509C82.7832 6.36086 82.5626 5.63331 82.3181 4.82228C82.0736 5.63331 81.8492 6.36086 81.6459 7.00509C81.4417 7.64932 81.2412 8.26758 81.0437 8.86006L80.4146 10.6719Z'
          fill='#65558F'
        />
        <path d='M90.8209 2.76025V15.6155H88.5166V2.76025H90.8209Z' fill='#65558F' />
      </g>
    </svg>
  )
}

export function SidebarHeader({ handleCollapseClick, handleRoot }: Props) {
  const isPlugin = bridge.isInPlugin()

  if (isPlugin) {
    return (
      <div className='flex items-center h-10 px-3 shrink-0 bg-white gap-2'>
        <button
          onClick={handleCollapseClick}
          className='p-1.5 rounded-md hover:bg-gray-100 transition-colors shrink-0'
          aria-label='Close sidebar'
        >
          <svg
            width='18'
            height='18'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='text-tokens-neutral-icon-default'
          >
            <path
              d='M15 5L5 15M5 5L15 15'
              stroke='currentColor'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </button>
        <Logo handleRoot={handleRoot} />
        <div className='ml-auto'>
          <button
            onClick={handleRoot}
            className='p-1.5 rounded-md hover:bg-gray-100 transition-colors'
            aria-label='New chat'
          >
            <NewLogoSvg />
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className='px-6 py-4 flex items-center'>
      <div className='absolute top-0 left-0 px-6 py-4 flex items-center gap-2 z-50'>
        <CollapsedLogo handleCollapseClick={handleCollapseClick} />
        <Logo handleRoot={handleRoot} />
      </div>
      <div className='ml-auto mr-4'>
        <NewLogo handleRoot={handleRoot} />
      </div>
    </div>
  )
}
